export const selectorPeticioObtenirEstructuraIDadesEnCurs = state => state.estacio.formulari.peticioObtenirEstructuraIDadesEnCurs;



// WEBPACK FOOTER //
// ./src/selectors/selector_estacio_peticio_obtenir_estructura_i_dades_en_curs.js